import reducer from './sellerconfig.reducer';

export {
  getSellerConfigPage,
} from './sellerconfig.action';

export default reducer;
